module.exports = __webpack_public_path__ + "static/img/integral.be41947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integral.png
// module id = 3uTd
// module chunks = 1